import { httpRequest } from "../../http";
import { AggregateVersion } from "@models/aggregateVersion.model";

/**
 * One vertical's metrics-catalog history (MPN-1335).
 *
 * No catalog-specific version model: the response is exactly `AggregateVersion`. An ingest version
 * carries a run count because runs pin it; nothing pins a catalog version, so there is no extra
 * field to model.
 */
export class CommandListCatalogVersions {
  async run(verticalId: number): Promise<AggregateVersion[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/${verticalId}/catalog-versions/`;
    return httpRequest<AggregateVersion[]>(url, { method: "GET" });
  }
}

/** Domain triggers on top of the universal three. Read with the author, never alone: the system
 *  user is behind the baseline, the seed and every key rename, and those read differently. */
export const CATALOG_TRIGGER_LABELS: Record<string, string> = {
  metric_key_renamed: "renamed a metric key",
  catalog_seeded: "catalog seed run",
};
